<script setup>
import { computed, onMounted, onBeforeUnmount } from 'vue';
import { getEventKeyCode } from 'utils';

const props = defineProps({
  images: {
    type: Array,
    required: true,
  },
  index: {
    type: [Number, null],
    required: false,
    default: null,
  },
});

const emit = defineEmits(['close']);

function close() {
  emit('close');
}

function keyUpListener(e) {
  if (getEventKeyCode(e) === 27) {
    close();
  }
}

onMounted(() => {
  window.addEventListener('keyup', keyUpListener, false);
});

onBeforeUnmount(() => {
  window.removeEventListener('keyup', keyUpListener, false);
});

const isVisible = computed(() => props.index !== null && props.index !== undefined);

const preparedImages = computed(() => {
  if (props.images) {
    return props.images.map((image) => {
      if (typeof image === 'string') {
        return {
          src: image,
        };
      }

      return image;
    });
  }

  return [];
});

// TODO maybe extend with prev/next actions
</script>

<template>
  <Teleport to="body">
    <transition name="gallery">
      <div
        v-if="isVisible"
        class="ce-gallery">
        <a
          href=""
          class="ce-gallery-closeCta"
          @click.prevent="close">
          <fa-icon icon="times" />
        </a>

        <div class="ce-galleryInner">
          <div
            v-for="(image, imageIndex) in preparedImages"
            :key="imageIndex"
            class="ce-gallery-entry">
            <template v-if="imageIndex === index">
              <div class="ce-gallery-image-wrapper">
                <img :src="image.src">
              </div>

              <div
                v-if="image.title"
                class="ce-gallery-image-text">
                {{ image.title }}
              </div>
            </template>
          </div>
        </div>
      </div>
    </transition>
  </Teleport>
</template>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-gallery {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: fade(@color-mono-0, 80);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9900;
  transition: opacity 0.3s ease;

  .ce-gallery-closeCta {
    position: absolute;
    top: @space-1;
    right: @space-1;
    color: @color-mono-100;
    .ms(6);
    padding: @space-2;
  }

  .ce-galleryInner {
    max-width: 90%;
    max-height: 90%;
    overflow-x: hidden;
    overflow-y: auto;
    position: relative;
    display: flex;

    .ce-gallery-entry {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex: 1 1 auto;

      .ce-gallery-image-wrapper {
        flex: 1 1 auto;
        overflow: hidden;

        img {
          display: block;
          max-width: 100%;
          max-height: 100%;
        }
      }

      .ce-gallery-image-text {
        flex: none;
        color: @color-mono-100;
        text-align: center;
        margin-top: @space-2;
      }
    }
  }
}

.gallery-enter-from {
  opacity: 0;
}

.gallery-leave-to {
  opacity: 0;
}
</style>
